module.exports = __webpack_public_path__ + "static/media/logo-centroguilherme.12140b86.png";